var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconThemeLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2476 14.5347C17.8797 15.0848 16.3803 15.2207 14.9358 14.9256C13.4913 14.6305 12.1654 13.9174 11.1228 12.8748C10.0803 11.8323 9.36714 10.5064 9.07202 9.06183C8.77691 7.61731 8.91284 6.1179 9.46292 4.75C7.84303 5.40248 6.50055 6.59813 5.66563 8.13197C4.83071 9.66581 4.55533 11.4423 4.88672 13.1569C5.2181 14.8716 6.13561 16.4175 7.48195 17.5298C8.82828 18.6421 10.5196 19.2514 12.266 19.2533C13.7677 19.2533 15.2351 18.804 16.4793 17.9631C17.7236 17.1222 18.6877 15.9282 19.2476 14.5347Z",
    stroke: "#171717",
    strokeWidth: 1.67146,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThemeLight);
export default __webpack_public_path__ + "static/media/icon-theme-light.4278a4a2aefb33b097b4dbc03578395a.svg";
export { ForwardRef as ReactComponent };